function fixedHeaderInit() {
    const siteHeader = document.querySelector(".site-header--sticky");
    const siteHeaderFixedClass = "site-header--fixed";
    const siteHeaderFixedMinimumWidth = 320;

    if (siteHeader) {
        if (window.innerWidth >= siteHeaderFixedMinimumWidth) {
            var siteHeaderHeight = siteHeader.offsetHeight + siteHeader.offsetTop;
            headerFixedDecision(siteHeaderHeight);
        }
    }

    function headerFixedDecision(fixedStartPosition) {
        window.addEventListener('scroll', function () {
            if (window.innerWidth >= siteHeaderFixedMinimumWidth) {
                var scrollPosition = window.pageYOffset;
                if (scrollPosition >= fixedStartPosition) {
                    if (!document.body.classList.contains(siteHeaderFixedClass)) {
                        siteHeader.classList.add(siteHeaderFixedClass);
                    }
                } else {
                    siteHeader.classList.remove(siteHeaderFixedClass);
                }
            }
        });
    }
}
